import React from "react";
import { SRC_STYLE } from "./wsUtils";

export function SourceTag({ src, labels, zh, testid }) {
  const key = src?.src || src || "pending";
  const lbl = labels?.[key] ? (zh ? labels[key].zh : labels[key].en) : key;
  return (
    <span data-testid={testid} data-src={key} title={src?.by ? `${lbl} · ${src.by}` : lbl}
      className={`inline-flex items-center rounded-full border px-1.5 py-[1px] text-[10px] leading-4 whitespace-nowrap ${SRC_STYLE[key] || SRC_STYLE.template}`}>
      {lbl}
    </span>
  );
}
